/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Manuelleerfahrungsstufe1Inputs */



/**

* @param {_Field_Manuelleerfahrungsstufe1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_manuelleerfahrungsstufe1 = /** @type {((inputs?: _Field_Manuelleerfahrungsstufe1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Manuelleerfahrungsstufe1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Manuelle Erfahrungsstufe")
});
export { _field_manuelleerfahrungsstufe1 as "_field_manuelleErfahrungsstufe" }